import { useEffect } from 'react';

import useRouter from 'Hooks/useRouter';

const CaseInsensitiveRedirect = () => {
  const { location, navigate } = useRouter();

  useEffect(() => {
    if (location.pathname !== location.pathname.toLowerCase()) {
      navigate(location.pathname.toLowerCase(), { replace: true });
    }
  }, [location, navigate]);

  return null;
};

CaseInsensitiveRedirect.propTypes = {
};

CaseInsensitiveRedirect.displayName = 'CaseInsensitiveRedirect';

export { CaseInsensitiveRedirect };
